import * as Colors from '@brightlayer-ui/colors';

export const Styles = {
    divider: { marginBottom: '28px', marginTop: '18px' },
    formLabel: { paddingBottom: '6px', rem: 1.125 },
    errorMessage: { color: Colors.red[500] },
    modalSpinner: { display: 'flex', margin: 'auto', padding: '26px 100px 20px 100px' },
};
